import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { createSelector } from "reselect";
import { Button, Form, Input, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
// hooks
import { useRedux } from "../../../hooks/index";
import { swapChatRooms, fetchChatContactsRequest } from "../../../redux/chats/slice";
import { debounce } from "lodash";
import classnames from "classnames";
import { findForFilterChatroomSale, findForFilterChatroomCs, findForFilterChatroomProvince } from "../../../redux/actions";
import { setActivePostId2 } from "../../../redux/workplace/wpActions";
import { WpSliceData } from "../../../redux/workplace/wpTypes";
// actions
import {
  inviteContact,
  resetContacts,
  getFavourites,
  getDirectMessages,
  getChannels,
  addContacts,
  createChannel,
  changeSelectedChat,
  getChatUserDetails,
  getChatUserConversations2,
  getChannelDetails,
  getChatUserDetails2s,
  getArchiveContact,
  readConversation,

  getChatRoomLists,
  setActiveGroupId,
  loadCustomerContent,
  changeSelectedContentTitle
} from "../../../redux/actions";

// interfaces
import { CreateChannelPostData } from "../../../redux/actions";

// components
import AppSimpleBar from "../../../components/AppSimpleBar";
import AddGroupModal from "../../../components/AddGroupModal";
import InviteContactModal from "../../../components/InviteContactModal";
import AddButton from "../../../components/AddButton";
import ContactModal from "../../../components/ContactModal";

import Favourites from "./Favourites";
import ChatRoomList from "./ChatRoomList";
import DirectMessages from "./DirectMessages";
import Chanels from "./Chanels";
import Archive from "./Archive";
import { CHATS_TABS, FILTER_CHAT_ROOM_TABS, TABS, WpModes } from "../../../constants";
import { Utils } from "../../../helpers/utils";
import { UserTypes } from "api";
import { UserTypes as UserStruct } from "../../../data/chat";
import InviteCodeModal from "components/InviteCodeModal";
import CustomerContent from "./CustomerContent";
import { Console } from "console";
import CreateChatRoomModal from "components/CreateChatRoomModal";
import FilterChatRoomModal from "components/FilterChatRoomModal";
import { FilterConfig } from "components/FilterChatRoomModal";
import TextBox from "components/TextBox";
import UserProfileModal from "components/UserProfileModal";
import { SKeys } from "const";


interface IndexProps {
  groupType: UserTypes
}
const Index = ({ groupType }: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Contacts,
    (props: any) => props.Chats,
    (profile2: any) => profile2.Profile2,
    (state: any) => state.ChatContacts2,
    (state: any) => state.WpSlice,
    (state, props, profile2, c2, wp: WpSliceData) => ({
      isContactInvited: state.isContactInvited,
      favourites: props.favourites,
      // chatRoomLists: props.chatRoomLists,
      chatRoomLists: c2.chatContacts,
      directMessages: props.directMessages,
      channels: props.channels,
      isContactsAdded: props.isContactsAdded,
      isChannelCreated: props.isChannelCreated,
      selectedChat: props.selectedChat,
      isFavouriteContactToggled: props.isFavouriteContactToggled,
      archiveContacts: props.archiveContacts,
      isContactArchiveToggled: props.isContactArchiveToggled,
      chatUserDetails: props.chatUserDetails,
      profile2: profile2,
      activeGroupId: profile2.activeGroupId,
      custContents: props.custContents,
      isViewAs: profile2.isViewAs,
      isOpenUserDetails: props.isOpenUserDetails, /*tab group profile open?*/
      isOpenUserDetailsTab: props.isOpenUserDetailsTab, /*what tab active */
      activePostId: wp.activePostInfo.postId,
    })
  );

  // Inside your component
  const {
    isContactInvited, favourites, chatRoomLists, directMessages
    , channels, isContactsAdded, isChannelCreated, selectedChat, isFavouriteContactToggled
    , archiveContacts, isContactArchiveToggled, chatUserDetails, profile2
    , activeGroupId, custContents
    , isViewAs
    , isOpenUserDetails, isOpenUserDetailsTab
    , activePostId
  } = useAppSelector(errorData);

  // get data

  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch]');
    dispatch(getFavourites());
    // #DEFINE WAIT NEW VERSION dispatch(getChatRoomLists());
    if (activeGroupId && profile2.userType == UserTypes.Customer) dispatch(loadCustomerContent(activeGroupId));
    dispatch(getDirectMessages());
    dispatch(getChannels());
  }, [dispatch, isViewAs]);

  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch, isFavouriteContactToggled]');
    if (isFavouriteContactToggled) {
      dispatch(getFavourites());
      // #DEFINE WAIT NEW VERSION dispatch(getChatRoomLists());
      dispatch(getDirectMessages());
    }
  }, [dispatch, isFavouriteContactToggled]);

  /*
  invite contact modal handeling
  */
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenInviteCode, setIsOpenInviteCode] = useState<boolean>(false);
  const [isOpenModalCreateRoom, setIsOpenModalCreateRoom] = useState<boolean>(false);
  const [isFilterChatRoomModalOpen, setIsFilterChatRoomModalOpen] = useState<boolean>(false);

  const [filterChatRoom, setFilterChatRoom] = useState<FilterConfig>({
    selTab: FILTER_CHAT_ROOM_TABS.SALES,
    unRead: false,
    personUnRead: false,
    topRow: 100,
    noActivity: false,
    keywordChatRoom: "",
    keywordSales: "",
    keywordCs: "",
    keywordProvince: "",
    // ticks:0,
    keySelected: [],
    customerIsCdSys: ""
  });

  const openModal = () => { setIsOpen(true); };

  const openModalInviteCode = () => { setIsOpenInviteCode(true); }

  const openModalAddNewChatRoom = () => { setIsOpenModalCreateRoom(true); }

  const closeModalAddNewChatRoom = () => { setIsOpenModalCreateRoom(false); }

  const closeModal = () => { setIsOpen(false); };

  const clostModalInviteCode = () => { setIsOpenInviteCode(false); }

  /*
  onInvite handeling
  */
  const onInviteContact = (data: any) => {
    dispatch(inviteContact(data));
  };
  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch, isContactInvited]');
    if (isContactInvited) {
      setIsOpen(false);
      setTimeout(() => {
        dispatch(resetContacts("isContactInvited", false));
      }, 1000);
    }
  }, [dispatch, isContactInvited]);

  /*
  contact add handeling
  */
  const [isOpenAddContact, setIsOpenAddContact] = useState<boolean>(false);
  const openAddContactModal = () => {
    setIsOpenAddContact(true);
  };
  const closeAddContactModal = () => {
    setIsOpenAddContact(false);
  };
  const onAddContact = (contacts: Array<string | number>) => {
    dispatch(addContacts(contacts));
  };
  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch, isContactsAdded]');
    if (isContactsAdded) {
      setIsOpenAddContact(false);
      dispatch(getDirectMessages());
    }
  }, [dispatch, isContactsAdded]);

  /*
  channel creation handeling
  */
  const [isOpenCreateChannel, setIsOpenCreateChannel] = useState<boolean>(false);
  const openCreateChannelModal = () => {
    setIsOpenCreateChannel(true);
  };
  const closeCreateChannelModal = () => {
    setIsOpenCreateChannel(false);
  };
  const onCreateChannel = (channelData: CreateChannelPostData) => {
    dispatch(createChannel(channelData));
  };
  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch, isChannelCreated]');
    if (isChannelCreated) {
      setIsOpenCreateChannel(false);
      dispatch(getChannels());
    }
  }, [dispatch, isChannelCreated]);

  /*
  select chat handeling :
    get conversations
    get chat user details
  */

  const [isUserProfileModalOpen, setIsUserProfileModalOpen] = useState<boolean>(false);

  const [lastChatIdLoadProfile, setLastChatIdLoadProfile] = useState(-1);
  const [lastChatIdLoadErp, setLastChatIdLoadErp] = useState(-1);
  const [toggleReloadProfile, setToggleReloadProfile] = useState<boolean>(false);
  useEffect(() => {
    // 20250227 always load profile because have to use member in group for tag function
    // console.log('reload profile 2');
    dispatch(getChatUserDetails2s(selectedChat, false, true, false));
    setLastChatIdLoadProfile(selectedChat);

    if (isOpenUserDetails) {
      const isTabProfile = isOpenUserDetailsTab === undefined || isOpenUserDetailsTab == 0;
      const isTabErp = profile2.userType == UserTypes.Employee && !isTabProfile;
      if (isTabProfile && lastChatIdLoadProfile != selectedChat) {
        // console.log('Load Profile of ' + selectedChat)
        // dispatch(getChatUserDetails2s(selectedChat, false, true, false));
        // setLastChatIdLoadProfile(selectedChat);
      } else if (isTabErp && lastChatIdLoadErp != selectedChat) {
        // console.log('Load ERP of ' + selectedChat)
        dispatch(getChatUserDetails2s(selectedChat, false, false, true));
        setLastChatIdLoadErp(selectedChat);
      }
      // console.log({isOpenUserDetails, isOpenUserDetailsTab});
      // console.log('load chat id = ' + selectedChat + ":" + (isOpenUserDetailsTab === undefined || isOpenUserDetailsTab == 0 ? "profile" : "ERP"));
    } else {
      setLastChatIdLoadErp(-1);
    }
    // console.log({isOpenUserDetails, isOpenUserDetailsTab});
  }, [toggleReloadProfile, selectedChat, isOpenUserDetails, isOpenUserDetailsTab]);

  const onSelectChat = (id: string | number, isChannel?: boolean) => {
    // console.log('onSelectChat:' + id);
    if (id == selectedChat) { // click same group
      setToggleReloadProfile(prev => !prev);
    }
    //console.log('onSelectChat:', { id, isChannel });
    // console.log(chatUserDetails);
    dispatch(changeSelectedChat(id)); // move from bottom to this area
    dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "Clear because select chat room"));
    const is2s = Utils.IsNumeric(id);
    if (is2s) {
      // console.log('get user details from 2s ' + id);
      // dispatch(getChatUserDetails2s(id, false)); -> move to userEffect when selectChat or Tab changed
      // dispatch(getChatUserDetails2s(selectedChat, false, true, false));
      // setLastChatIdLoadProfile(selectedChat);
    } else {
      // console.log('get user details from fake ' + id);
      if (isChannel) {
        dispatch(getChannelDetails(id));
      } else {
        dispatch(getChatUserDetails(id));
      }
    }
    dispatch(readConversation(id));
    dispatch(getChatUserConversations2(id, null, null, null, null, null, "On select chat room"));
    //console.log('Dashboard.Chats.selectedChat = ' + id);
    // dispatch(changeSelectedChat(id));
  };

  const onReloadChatRoomList = async () => {
    try {
      performSearchContact();
      if (activeGroupId && profile2.userType == UserTypes.Customer) dispatch(loadCustomerContent(activeGroupId));
    } catch (e) {
      alert((e as Error).message);
    }
  }

  /*
  tab handeling
  */
  const [active, setActive] = useState(CHATS_TABS.DEFAULT);
  const onChangeTab = (tab: CHATS_TABS) => {
    setActive(tab);
  };

  /*
  archive contacts
  */
  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch]');
    dispatch(getArchiveContact());
  }, [dispatch]);

  useEffect(() => {
    // console.log('ChatIndex.useEffect.[dispatch, isContactArchiveToggled, chatUserDetails.id]');
    if (isContactArchiveToggled) {
      dispatch(getArchiveContact());
      dispatch(getFavourites());
      // #DEFINE WAIT NEW VERSION dispatch(getChatRoomLists());
      if (activeGroupId && profile2.userType == UserTypes.Customer) dispatch(loadCustomerContent(activeGroupId));
      dispatch(getDirectMessages());
      dispatch(getChannels());
      dispatch(getChatUserDetails(chatUserDetails.id));
    }
  }, [dispatch, isContactArchiveToggled, chatUserDetails.id]);

  const debouncePerformSearchContact = debounce(() => {
    performSearchContact();
  }, 1000); // Adjust the debounce time as necessary       

  const onSearchContractKeyUp = () => {
    debouncePerformSearchContact();
  }

  const [serachChatUserKeyword, setSerachChatUserKeyword] = useState<any>('');

  const performSearchContact = () => {
    const inputValue: any = document.getElementById("serachChatUser");
    const filter = inputValue?.value;
    let filterSaleId = new Array();
    let filterCsId = new Array();
    let filterProvinceId = new Array();
    (filterChatRoom.keySelected ?? []).map((el: any) => {
      if (el.mode == FILTER_CHAT_ROOM_TABS.SALES) filterSaleId.push(el.keyId);
      else if (el.mode == FILTER_CHAT_ROOM_TABS.CS) filterCsId.push(el.keyId);
      else if (el.mode == FILTER_CHAT_ROOM_TABS.PROVINCE) filterProvinceId.push(el.keyId);
    });
    // console.log([filterSaleId, filterCsId, filterProvinceId]);
    setSerachChatUserKeyword(filter);
    //console.log('start filter keyword:' + filter);
    const parm = {
      page: 1,
      filter: filter,
      isFetchNext: false,
      filterUnread: filterChatRoom.unRead,
      filterPersonUnRead: filterChatRoom.personUnRead,
      filterNoActivity: filterChatRoom.noActivity,
      filterSaleIds: filterSaleId,
      filterCsIds: filterCsId,
      filterProvinceIds: filterProvinceId,
      groupType: groupType,
      currentSelectedChatId: selectedChat,
      companyType: filterChatRoom.customerIsCdSys
    }
    // console.log('filter parm:', parm);
    dispatch(fetchChatContactsRequest(parm))
  }

  const [isStartLoad, setIsStartLoad] = useState<boolean>(true);

  useEffect(() => {
    // console.log('filter chatroom changed');
    if (!isStartLoad) {
      performSearchContact();
    } else {
      // console.log('filter load ddl');
      dispatch(findForFilterChatroomSale(filterChatRoom.unRead, filterChatRoom.personUnRead, filterChatRoom.noActivity, filterChatRoom.topRow, filterChatRoom.keywordSales));
      dispatch(findForFilterChatroomCs(filterChatRoom.unRead, filterChatRoom.personUnRead, filterChatRoom.noActivity, filterChatRoom.topRow, filterChatRoom.keywordCs));
      dispatch(findForFilterChatroomProvince(filterChatRoom.unRead, filterChatRoom.personUnRead, filterChatRoom.noActivity, filterChatRoom.topRow, filterChatRoom.keywordProvince));
    }
    setIsStartLoad(false);
  }, [filterChatRoom])

  const onClearKeyword = async () => {
    const txt: any = document.getElementById("serachChatUser");
    if (txt) txt.value = '';
    performSearchContact(); // change to immediately search
    //debouncePerformSearchContact();
  }

  const onFilterButtonClick = () => {
    setIsFilterChatRoomModalOpen(true);
    // alert('Under Construction');
  }

  //serach recent user
  const searchUsers = () => {
    onSearchContractKeyUp();
    // var li, a, i, txtValue: any;
    // const inputValue: any = document.getElementById("serachChatUser");
    // const filter: any = inputValue.value.toUpperCase();
    // const ul: any = document.querySelector(".chat-room-list");
    // li = ul.getElementsByTagName("li");
    // for (i = 0; i < li.length; i++) {
    //   a = li[i].getElementsByTagName("a")[0];
    //   txtValue = a.textContent || a.innerText;
    //   if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //     li[i].style.display = "";
    //   } else {
    //     li[i].style.display = "none";
    //   }
    // }
  };

  const [chatTitle, setChatTitle] = useState("Chats");
  const location = useLocation();

  //const chatTitle = profile2 && profile2.userType == UserTypes.Customer ? Utils.GetFirstNotNull("bb", profile2.companyName, profile2.fullName, profile2.NickName) : "Chats";
  const isEmployee = Utils.Is2S(profile2);
  const isCustomer = profile2?.userType == UserTypes.Customer;// !Utils.Is2S(profile2);
  const isSupplier = profile2?.userType == UserTypes.Supplier;

  // console.log('isCustomer:' + isCustomer);
  // console.log('profile2:',profile2);

  const [activeCompanyName, setActiveCompanyName] = useState<string>("");

  // useEffect(() => {
  //   console.log('URL changed:', location.pathname);
  //   // check if open by direct message
  //   const queryParams = new URLSearchParams(location.search);    
  //   const chatId  = 57635;//queryParams.get('cid');
  //   if (chatId){
  //     dispatch(setActiveGroupId(chatId));
  //     dispatch(changeSelectedChat(chatId));
  //   }
  // }, [location]);

  useEffect(() => {


    // console.log('ChatIndex.useEffect.[, activeGroupId, chatRoomLists]');
    if (!activeGroupId && chatRoomLists && chatRoomLists.length > 0) {
      const memRoomId = localStorage.getItem(SKeys.EmbMemRoomId);
      const index = chatRoomLists.findIndex((e: any) => e.userId == memRoomId);
      // console.log('skeys.EmbMemRoomId = ' + memRoomId + ', found index from contact is ' + index);
      if (memRoomId && index !== -1) {
        onChangeCompany(memRoomId);
        // console.log('change company to ' + memRoomId);
        // localStorage.setItem("MemRoomId", memRoomId);
      } else {
        onChangeCompany(chatRoomLists[0].userId/*id*/);
        // localStorage.setItem("MemRoomId", chatRoomLists[0].userId);
      }

      // console.log('activeGroupId is nothing, dispatch it to ' + chatRoomLists[0].id);
      // dispatch(setActiveGroupId(chatRoomLists[0].id));
      // onChangeCompany(chatRoomLists[0].userId/*id*/);
    } else { // change active chat
      // console.log('activeGroupId change to ' + activeGroupId);
      for (var i = 0; i < chatRoomLists.length; ++i) {
        if (chatRoomLists[i].userId/*id*/ == activeGroupId) {
          // console.log('set title:', chatRoomLists[i]);
          // console.log(chatRoomLists[i].firstName + ' ' + chatRoomLists[i].lastName);
          setActiveCompanyName(chatRoomLists[i].fullName /* chatRoomLists[i].firstName + ' ' + chatRoomLists[i].lastName*/);
          if (!isEmployee /*isCustomer*/) {
            setChatTitle(chatRoomLists[i].fullName /* chatRoomLists[i].firstName + ' ' + chatRoomLists[i].lastName*/);
          } else {
            //setChatTitle("Chats");
            let title = "Chats";
            if (groupType == UserTypes.Group) title = "Chat Customer";
            else if (groupType == UserTypes.GroupSupplier) title = "Chat Supplier";
            setChatTitle(title);
          }
        }
      }
    }
  }, [, activeGroupId, chatRoomLists, isCustomer, isEmployee]);

  useEffect(() => {
    // console.log('ChatIndex.useEffect.[activeGroupId]');
    // console.log('useEffect.activeGroupId = ' + activeGroupId);
    if (activeGroupId && profile2.userType == UserTypes.Customer) dispatch(loadCustomerContent(activeGroupId));
  }, [activeGroupId]);


  const onChangeCompany = (id: any) => {
    const idNumber = id ? Utils.ToNumber(id, null) : id;
    localStorage.setItem(SKeys.EmbMemRoomId, idNumber);
    localStorage.removeItem("lastActiveTitle");
    const isMemRoomIdAutoSelect = localStorage.getItem(SKeys.EmbMemRoomAutoSel) === "1";
    // console.log('const onChangeCompany = (id: any) => :', id);
    dispatch(setActiveGroupId(idNumber));
    dispatch(changeSelectedContentTitle(idNumber, null, 'onChangeCompany'));
    // console.log('onChangeCompany:', { id, idNumber, isMemRoomIdAutoSelect });
    if (isMemRoomIdAutoSelect) {
      dispatch(changeSelectedChat(idNumber));
    } else {
      dispatch(changeSelectedChat(null));
    }
    if (activePostId) { // 20250715
      dispatch(setActivePostId2(WpModes.Workplace, null, null, null, null, null, "Clear because change company"));
    }

    // const isInFrame = localStorage.getItem(SKeys.EmbInFrame) == "1";
    const isInFrame = window.self !== window.top;
    console.log('isInFrame:', isInFrame);
    if (!isInFrame) { // 20251030 test not rememove this flag when run in frame, because when use frame from 2slince seem this function run twice. Second time this flag is gone, then no active gorup select.
      // console.log('remove EmbMemRoomAutoSel');
      localStorage.removeItem(SKeys.EmbMemRoomAutoSel);
    }
  }

  const ChatTitle = () => {
    // console.log('ChatTitle IsCustomer = ' + isCustomer);
    // State to manage whether the dropdown is open or not
    const [dropdownOpen, setDropdownOpen] = useState(false);


    // Function to toggle the dropdown's open/close state
    const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);


    const TitleFor2S = () => {
      return (<h4>{chatTitle}</h4>)
    }

    const css_unread = localStorage.getItem("lm") == "dark" ? "badge-soft-dark" : "badge-soft-light";

    const TitleForCust = () => {
      if (!chatRoomLists || chatRoomLists.length <= 1) return (<h4>{chatTitle}</h4>);

      return (
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle nav className="bg-transparent">
            <h4>{chatRoomLists && chatRoomLists.length > 1 && ('🔻')} {activeCompanyName}</h4>
          </DropdownToggle>
          <DropdownMenu style={{ width: "250px" }}>
            {chatRoomLists.map((room: any, key: number) => (
              <DropdownItem key={key} onClick={() => onChangeCompany(room.userId/*id*/)} >
                {/* {'🔸 ' + room.fullName }
                {room.unreadCount && room.unreadCount > 0 ? (
                  <>&nbsp;&nbsp;
                  <span className="text-truncate mb-0 unread-badge-p" >
                    <span className={"badge " + css_unread + " unread-badge rounded p-1 "}>{room.unreadCount}</span>
                  </span>
                  </>
                ) : null} */}
                <div className="d-flex align-items-center ">
                  <div className="overflow-hidden">
                    {'🔸 ' + room.fullName}
                  </div>
                  {room.unreadCount && room.unreadCount > 0 ? (
                    <div className="ms-auto text-end">
                      <span className="text-truncate mb-0 unread-badge-p" >
                        <span className={"badge " + css_unread + " unread-badge rounded p-1 "}>{room.unreadCount}</span>
                      </span>
                    </div>
                  ) : null}
                </div>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      );
    }
    //return isCustomer ? (<TitleForCust></TitleForCust>) : (<TitleFor2S></TitleFor2S>);
    return isEmployee ? (<TitleFor2S></TitleFor2S>) : (<TitleForCust></TitleForCust>);
  };

  const onTestClick = () => {
    dispatch(swapChatRooms({ index1: 0, index2: 10 }));
  }

  // console.log('chatRoomLists:', chatRoomLists);

  // const [filterSelectedTab, setFilterSelectedTab] = useState<FILTER_CHAT_ROOM_TABS>(FILTER_CHAT_ROOM_TABS.CHAT_ROOM);
  // const [filterChatRoom, setFilterChatRoom] = useState<string>("");
  // const [filterSale, setFilterSale] = useState<string>("");
  // const [filterCs, setFilterCs] = useState<string>("");
  // const [filterProvince, setFilterProvince] = useState<string>("");

  // const [filterChatRoomRs, setFilterChatRoomRs] = useState<any[]>([]);
  // const [filterSaleRs, setFilterSaleRs] = useState<any[]>([]);
  // const [filterCsRs, setFilterCsRs] = useState<any[]>([]);
  // const [filterProvinceRs, setFilterProvinceRs] = useState<any[]>([]);

  // const debounceFilterSearch = useCallback(
  //   debounce((mode, filter, filterUnRead, filterNoActivity) => {
  //     //dispatch(findMemberToGroup(groupId, filter, filterUserType));
  //     console.log('finding : mode = ' + mode + ', filter = ' + filter + `, unread = ${filterUnRead}, no activity = ${filterNoActivity}`);
  //   }, 500)
  //   , [] // Adjust the debounce time as necessary             
  // )

  // const onFilterChange = (mode: FILTER_CHAT_ROOM_TABS, filter: string | null, filterUnread: boolean | null, filterNoActivity: boolean | null) => {
  //   if (filter) {
  //     if (mode == FILTER_CHAT_ROOM_TABS.CHAT_ROOM) setFilterChatRoom(filter);
  //     else if (mode == FILTER_CHAT_ROOM_TABS.SALES) setFilterSale(filter);
  //     else if (mode == FILTER_CHAT_ROOM_TABS.CS) setFilterCs(filter);
  //     else if (mode == FILTER_CHAT_ROOM_TABS.PROVINCE) setFilterProvince(filter);
  //   }
  //   setFilterSelectedTab(mode);
  //   debounceFilterSearch(mode, filter, filterUnread, filterNoActivity);
  //   // console.log(filterChatRoom);
  // }



  // const [keySelected, setKeySelected] = useState<any[]>([]);
  const [keyDisplaySelected, setKeyDisplaySelected] = useState<any[]>([]);
  // const onKeySelected = (mode: FILTER_CHAT_ROOM_TABS, keyId: any, keyDisplay: string) => {
  //   const val = { mode, keyId, keyDisplay }

  //   // Check if the uniqueKey exists in the array
  //   setKeySelected(prevSelected => {
  //     const isAlreadySelected = prevSelected.some(item => item.mode == mode && item.keyId == keyId);
  //     if (isAlreadySelected) {
  //       // If the key exists, remove it
  //       return prevSelected.filter(item => !(item.mode == mode && item.keyId == keyId));
  //     } else {
  //       // If the key doesn't exist, add it
  //       return [...prevSelected, val];
  //     }
  //   });
  // }

  // const onKeySelectedDel = (keyDisplay: string) => {
  //   setKeySelected(prevSelected => {
  //     return prevSelected.filter(item => item.keyDisplay != keyDisplay);
  //   });
  // }

  useEffect(() => {
    // clear filter
    localStorage.removeItem("ch-flt");
  }, [])

  const filterIcon =
    filterChatRoom.unRead || filterChatRoom.personUnRead || filterChatRoom.noActivity || filterChatRoom.keySelected.length > 0 || filterChatRoom.customerIsCdSys != ""
      ? 'bx bxs-filter-alt' : 'bx bx-filter-alt';

  return (
    <>
      <div className="">
        <div className="px-4 pt-4">
          <div className="d-flex align-items-start">
            <div className="flex-grow-1">
              {/* <h4 className="mb-4">{chatTitle}</h4> */}
              <ChatTitle></ChatTitle>
              {/* <button onClick={onTestClick}>test</button> */}
            </div>

            {isCustomer && (
              <div className="flex-shrink-0">
                <div id="add-contact">
                  {/* Button trigger modal */}
                  {/* <AddButton onClick={openModal} /> */}
                  <AddButton onClick={openModalInviteCode} />
                </div>
                {/* <UncontrolledTooltip target="add-contact" placement="bottom">
                  {isCustomer ? "รับรหัส เชิญสมาชิกเข้ากลุ่ม" : ""}
                </UncontrolledTooltip> */}
              </div>
            )}

            {isEmployee/* !isCustomer*/ && ( /*เพิ่มปุ่ม ให้ sell สร้างห้องไว้ก่อน*/
              <div className="flex-shrink-0">
                <div id="add-chat-room" title="สร้างห้องแชทใหม่">
                  <AddButton onClick={openModalAddNewChatRoom} />
                </div>
              </div>
            )}

          </div>
          {isEmployee /*!isCustomer*/ && (
            <Form>
              <div className="input-group mb-3">
                <Input
                  // onKeyUp={searchUsers} 20250304 change to not auto search
                  onChange={(e) => setSerachChatUserKeyword(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); performSearchContact(); } }}
                  id="serachChatUser"
                  type="text"
                  className="form-control bg-light border-0 pe-0"
                  placeholder="ค้นหา..."
                />
                {/* <Button color="light" type="button" id="searchbtn-addon">
                <i className="bx bx-search align-middle"></i>
              </Button> */}
                {serachChatUserKeyword && (
                  <Button color="light" type="button" id="btn-filter-clear" className="btn-filter" onClick={onClearKeyword}>
                    <i className='bx bxs-x-circle' ></i>
                  </Button>
                )}

                <Button color="light" type="button" id="btn-filter-search" className="btn-filter" onClick={performSearchContact}>
                  <i className="bx bx-search" ></i>
                </Button>

                {groupType == UserTypes.Group && (
                  <Button color="light" type="button" id="btn-filter-contract" className="btn-filter" onClick={onFilterButtonClick}>
                    <i className={filterIcon} ></i>
                  </Button>
                )}

              </div>
            </Form>
          )}
        </div>{" "}
        {/* .p-4 */}
        <AppSimpleBar className={classnames("chat-room-list", { "chat-room-list-cust": !isEmployee /*isCustomer*/ })}>
          {/* Start chat-message-list */}
          {active === CHATS_TABS.DEFAULT && (
            <>
              {/* chat room list */}
              <ChatRoomList
                users={chatRoomLists}
                selectedChat={selectedChat}
                onSelectChat={onSelectChat}
                onReloadChatList={onReloadChatRoomList}
                groupType={groupType}
              />

              <CustomerContent
                contents={custContents}
              />

            </>
          )}
          {active === CHATS_TABS.ARCHIVE && (
            <>
              <Archive
                archiveContacts={archiveContacts}
                selectedChat={selectedChat}
                onSelectChat={onSelectChat}
              />
              <h5 className="text-center mb-2">
                <Link
                  to="#"
                  className="mb-3 px-4 mt-4 font-size-11 text-primary"
                  onClick={() => onChangeTab(CHATS_TABS.DEFAULT)}
                >
                  Chats <i className="bx bxs-archive-out align-middle" />
                </Link>
              </h5>
            </>
          )}

          {/* End chat-message-list */}
        </AppSimpleBar>
      </div>
      {/* add group Modal */}
      {isOpenCreateChannel && (
        <AddGroupModal
          isOpen={isOpenCreateChannel}
          onClose={closeCreateChannelModal}
          onCreateChannel={onCreateChannel}
        />
      )}

      <UserProfileModal
        isOpen={isUserProfileModalOpen}
        userId={-1}
        onClose={closeCreateChannelModal}
      />

      {/* add contact modal */}
      {isOpen && (
        <InviteContactModal
          isOpen={isOpen}
          onClose={closeModal}
          onInvite={onInviteContact}
        />
      )}

      {isOpenInviteCode && (
        <InviteCodeModal
          isOpen={isOpenInviteCode}
          onClose={clostModalInviteCode}
          onReloadChatList={onReloadChatRoomList}
        />
      )}

      {isOpenModalCreateRoom && (
        <CreateChatRoomModal
          isOpen={isOpenModalCreateRoom}
          onClose={closeModalAddNewChatRoom}
          onSelectChat={onSelectChat}
          groupType={groupType}
        />
      )}

      {isFilterChatRoomModalOpen && (
        <FilterChatRoomModal
          isOpen={isFilterChatRoomModalOpen}
          onClose={() => setIsFilterChatRoomModalOpen((prev) => !prev)}
          onSelectChat={(id) => { }}
          // selectedTab={filterSelectedTab}
          // filterChatRoom={filterChatRoom}
          // filterSale={filterSale}
          // filterCs={filterCs}
          // filterProvince={filterProvince}
          // filterChatRoomRs={filterChatRoomRs}
          // filterSaleRs={filterSaleRs}
          // filterCsRs={filterCsRs}
          // filterProvinceRs={filterProvinceRs}
          // keySelected={keySelected}
          // onKeySelected={onKeySelected}
          // onKeySelectedDel={onKeySelectedDel}
          filterChatRoom={filterChatRoom}
          setFilterChatRoom={setFilterChatRoom}
        // keyDisplaySelected={keyDisplaySelected}
        // onFilterChange={onFilterChange}
        />
      )}

      {isOpenAddContact && (
        <ContactModal
          isOpen={isOpenAddContact}
          onClose={closeAddContactModal}
          onAddContact={onAddContact}
        />
      )}
    </>
  );
};

export default Index;
